<template>
  <section class="hero">
  <div class="hero-body">
    <div class="container">
      <h1 class="title is-1">
        Boules de Noël
      </h1>
      <!-- <h2 class="subtitle">
        Hero subtitle
      </h2> -->
    </div>
  </div>
</section>
</template>

<script>

export default {
name: 'Header',

}
</script>

<style>

</style>